export default "__VITE_ASSET__Bk3s5x13__"